<template>
  <v-container fluid>
        <v-row justify="end">
          <v-col>
            <h1>{{$t("scheduler.title")}}</h1>
          </v-col>
        </v-row>
        <ScheduleTable></ScheduleTable>
  </v-container>
</template>

<script>
import ScheduleTable from "../components/Scheduler/ScheduleTable";

export default {
    components: { ScheduleTable },
    computed: {
        ltxSpecificNavItems() {
            return this.$store.state.user.tenant === "ltx";
        },
        filterByTenant() {
            return this.$store.state.user.tenant === "ltx" ||
             this.$store.state.user.tenant === "kaista" ||
             this.$store.state.user.tenant === "taksi1" ||
             this.$store.state.user.tenant === "pohjanmaa-sote";
        }
    },
    methods: {
        navigate(name) {
            this.$router.push({ name: name });
        }
    }
};
</script>

<style scoped>
h1 {
    margin-bottom: 1rem;
}
</style>
